import { render } from "./MicButton.vue?vue&type=template&id=7d8bbbb2"
import script from "./MicButton.vue?vue&type=script&lang=js"
export * from "./MicButton.vue?vue&type=script&lang=js"

import "./MicButton.vue?vue&type=style&index=0&id=7d8bbbb2&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__